import React, { type FC } from 'react';
import {
    getBezierPath,
    EdgeLabelRenderer,
    BaseEdge,
    type EdgeProps,
    type Edge,
    useReactFlow,
} from 'reactflow';
import { IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { i18n } from '../../translate/i18n';

const EdgeConexaBot: FC<EdgeProps<Edge<{ label: string }>>> = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    selected,
    data,
}) => {
    const { setEdges } = useReactFlow(); // hook para manipular edges

    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const handleRemove = () => {
        setEdges((edges) => edges.filter((e) => e.id !== id));
    };

    return (
        <>
            <BaseEdge 
                id={id} 
                path={edgePath} 
                style={{
                    stroke: selected ? '#29b6f6' : 'rgb(96, 125, 139)', // azul se selecionado
                    strokeWidth: selected ? 3 : 2,
                }}
            />
            <EdgeLabelRenderer>
                <Tooltip
                    title={i18n.t("buttons.delete")}
                >
                    <IconButton
                        onClick={handleRemove}
                        sx={{
                            position: "absolute",
                            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                            pointerEvents: "all",
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                            background: (theme) =>
                                theme.palette.mode === "dark" ? "#f44336" : "#ef5350",
                            color: "#ffffff",
                            "&:hover": {
                                background: (theme) =>
                                    theme.palette.mode === "dark" ? "#e53935" : "#d32f2f",
                            },
                        }}
                        className="nodrag nopan"
                    >
                        <CloseIcon sx={{ width: "12px", height: "12px" }} />
                    </IconButton>
                </Tooltip>
            </EdgeLabelRenderer>
        </>
    );
};

export default EdgeConexaBot;
